module.exports = __webpack_public_path__ + "static/img/urgentnotice2.2b974e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/urgentnotice2.jpg
// module id = V9DA
// module chunks = 0